import { ApiDataAdapter } from '@internal-libraries/kheops-ui-lib'
import { get } from 'lodash'
import { BedDto } from '../Types/BedDto'
import Bed from '../Classes/ClvrBed'
import { HospitalRoomApiAdapter } from './HospitalRoomApiAdapter'

export class BedApiAdapter implements ApiDataAdapter<Bed> {
    public createClass(apiData: BedDto): Bed {
        const hospitalRoom = get(apiData, '_ref_chambre')

        const bed: Bed = new Bed({
            id: get(apiData, 'lit_id'),
            name: get(apiData, 'nom'),
            hospitalRoomId: get(apiData, 'chambre_id'),
        })

        if (hospitalRoom) {
            bed.hospitalRoom = new HospitalRoomApiAdapter().createClass(hospitalRoom)
        }

        return bed
    }
}
